<template>
  <div class="password-reset-form">
    <h2>Reset password</h2>
    <div class="opis_reset">
        <p>Please enter the email address that you used to register, and we will send you a link to reset your password via Email</p>
    </div>
    <DxForm :formData="resetData">
      <DxSimpleItem
        dataField="email"
        :editorOptions="{
          placeholder: 'Email',
          stylingMode: 'underlined',
          elementAttr: { style: 'background-color: #f0f0f0; border-bottom: 2px solid black; padding-left: 10px;  margin-bottom: 10px;' }
        }"
        :label="{ visible: false }"
      />
      <DxButtonItem
        :buttonOptions="{
          width: '100%',
          text: 'Reset Password',
          type: 'success',
          onClick: handleReset
        }"
        class="form-button"
      />
    </DxForm>
    <div class="sign-in-link">
      Remembered your password? <a href="#" @click.prevent="showLoginForm">Sign In</a>
    </div>
  </div>
</template>

<script>
import { DxForm, DxSimpleItem, DxButtonItem } from 'devextreme-vue/form';

export default {
  components: {
    DxForm,
    DxSimpleItem,
    DxButtonItem
  },
  data() {
    return {
      resetData: {
        email: ''
      }
    };
  },
  methods: {
    handleReset() {
      // Handle password reset logic here
      console.log('Reset data:', this.resetData);
    },
    showLoginForm() {
      // Emit an event to show the login form
      this.$emit('show-login-form');
    }
  }
};
</script>

<style scoped>
.password-reset-form {
  max-width: 400px;
  margin: 0 auto;
  /*padding: 20px;*/
  border-radius: 4px;
}

.password-reset-form h2 {
  color: var(--base-text-color);
  text-align: center;
  line-height: 24px;
  font-weight: 500;
  font-size: 24px;
  padding-bottom: 20px;
}

.opis_reset {
    color: var(--base-text-color-alpha);
    line-height: 16px;
    font-size: 12px;
    margin-top: 32px;
    text-align: center;
    padding-bottom: 20px;
}

.form-button {
  width: 100%;
  margin-top: 10px;
}

.sign-in-link {
  margin-top: 20px;
  text-align: center;
}

.sign-in-link a {
  color: #007bff;
  text-decoration: none;
}

.sign-in-link a:hover {
  text-decoration: underline;
}
</style>